import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'
import { on, addClass, selectAll } from 'helpers/dom'
import { map } from 'helpers/utils'
import { trapFocus, removeTrapFocus } from 'libs/accessibility'

const selectors = {
  CLOSE_SELECTOR: '.js-close-modal-dialog',
  CONTENT_SELECTOR: '.js-content-modal-dialog',
  OPEN_CLASS: 'modal-dialog-opened',
  OVERLAY_CLASS: 'modal-dialog-overlay',
  VALIDATE_FORM_CLASS: 'validate-form',
  TIMEOUT: 200
}

class ModalDialog extends HTMLElement {
  connectedCallback() {
    this.init()
  }

  init() {
    this.closeBtn = this.querySelectorAll(selectors.CLOSE_SELECTOR)
    this.contentEl = this.querySelector(selectors.CONTENT_SELECTOR)
    this.scrollTarget = this.getAttribute('data-scroll-target')
    this.attachEvents()
    this.addOverlay()
  }

  attachEvents() {
    this.closeBtn.forEach((btn) => on('click', this.hide.bind(this), btn))
    on('click', this.hide.bind(this), this)
    this.contentEl && on('click', (e) => e.stopPropagation(), this.contentEl)
    on(
      'keyup',
      (event) => {
        if (event.code.toUpperCase() === 'ESCAPE') this.hide()
      },
      this
    )
  }

  addOverlay() {
    if (!this.overlayEl) {
      this.overlayEl = document.createElement('div')
      addClass(selectors.OVERLAY_CLASS, this.overlayEl)
      this.insertBefore(this.overlayEl, this.contentEl)
    }
  }

  applyDisableBodyScroll(el) {
    disableBodyScroll(el, {
      allowTouchMove: (el) => {
        while (el && el !== document.body) {
          if (el.getAttribute('body-scroll-lock-ignore') !== null) {
            return true
          }

          el = el.parentElement
        }
      }
    })
  }

  show(target, init = false) {
    this.triggerEl = document.activeElement

    init && this.init()
    /** Hide all opened modal before open new modal */

    const allModals = document.querySelectorAll(selectors.OPEN_CLASS)

    allModals.forEach((modal) => modal.hide())

    this.setAttribute('open', '')
    this.classList.add(selectors.OPEN_CLASS)

    if (!target) {
      if (this.scrollTarget) {
        const scrollTargetEl = selectAll(this.scrollTarget, this)

        map(this.applyDisableBodyScroll, [...scrollTargetEl, this.contentEl])
      } else {
        this.applyDisableBodyScroll(this.contentEl)
      }
    } else {
      this.applyDisableBodyScroll(target)
    }

    setTimeout(() => {
      trapFocus(this.contentEl)
    }, selectors.TIMEOUT)
  }

  hide() {
    /** Refresh validate form when hide modal */
    const allFormsValidate = this.querySelectorAll(
      selectors.VALIDATE_FORM_CLASS
    )

    allFormsValidate.forEach((form) => form.refreshValidate())

    this.removeAttribute('open')
    this.classList.remove(selectors.OPEN_CLASS)
    clearAllBodyScrollLocks()
    this.dispatchEvent(new Event('close-modal'))
    removeTrapFocus()
    setTimeout(() => {
      this.triggerEl && this.triggerEl.focus()
    }, selectors.TIMEOUT)
  }
}

customElements.define('modal-dialog', ModalDialog)
